export const teams = [
	{
		id: "aguilas",
		name: "Águilas",
	},
	{
		id: "tropicales",
		name: "Tropicales",
	},
	{
		id: "vikingas",
		name: "Vikingas",
	},
	{
		id: "panas",
		name: "Las Panas",
	},
	{
		id: "panteras",
		name: "Panteras",
	},
	{
		id: "murallas",
		name: "Murallas",
	},
	{
		id: "espartanas",
		name: "Espartanas",
	},
	{
		id: 1,
		name: "1ro",
	},
	{
		id: 2,
		name: "2do",
	},
	{
		id: 3,
		name: "3ro",
	},
	{
		id: 4,
		name: "4to",
	},
	{
		id: 12,
		name: "Clasificado a la Final",
	},
	{
		id: 13,
		name: "Clasificado a la Final",
	},
];

export const locations = [
	{
		id: 1,
		name: "Jarama",
		address: "Av. de San Sebastián, 15",
	},
	{
		id: 2,
		name: "Aravaca",
		address: "",
	},
	{
		id: 3,
		name: "Getafe",
		address: "",
	},
	{
		id: 4,
		name: "Lago",
		address: "",
	},
	{
		id: 5,
		name: "Paracuellos de Jarama",
		address: "",
	},
];

export const locationTypes = {
	1: {
		icon: "map-pin",
		color: "secondary",
		label: "Jarama: Av. de San Sebastián, 15",
		link: "https://goo.gl/maps/gxmee9ZKVYunv4rB9",
	},
	5: {
		icon: "map-pin",
		color: "secondary",
		label: "Paracuellos de Jarama",
		link: "https://maps.app.goo.gl/9cwEPispp1nxERwS8?g_st=iw",
	},
};

export const scoreTypes = {
	1: {
		abbrev: "PJ",
		color: "secondary",
		label: "Partidos jugados",
	},
	2: {
		abbrev: "PG",
		color: "secondary",
		label: "Partidos Ganados",
	},
	3: {
		abbrev: "PP",
		color: "secondary",
		label: "Partidos Perdidos",
	},
	4: {
		abbrev: "PE",
		color: "secondary",
		label: "Partidos Empatados",
	},
	5: {
		abbrev: "CF",
		color: "secondary",
		label: "Carreras a favor",
	},
	6: {
		abbrev: "CC",
		color: "secondary",
		label: "Carreras en contra",
	},
	7: {
		abbrev: "DIF",
		color: "secondary",
		label: "Diferencia",
	},
	8: {
		abbrev: "PTS",
		color: "secondary",
		label: "Puntos",
	},
};

export const events = [
	[
		{
			id: 1,
			homeclubId: "aguilas",
			visitorId: "tropicales",
			locationId: 1,
			date: "2023-03-12T09:30:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 1,
		},
		{
			id: 2,
			homeclubId: "vikingas",
			visitorId: "tropicales",
			locationId: 1,
			date: "2023-03-12T11:20:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 0,
		},
		{
			id: 3,
			homeclubId: "espartanas",
			visitorId: "panteras",
			locationId: 1,
			date: "2023-03-12T13:10:00.000Z",
			scoreHomeclub: 6,
			scoreVisitor: 0,
		},
		{
			id: 4,
			homeclubId: "panas",
			visitorId: "murallas",
			locationId: 1,
			date: "2023-03-12T15:00:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 0,
		},
	],
	[
		{
			id: 5,
			homeclubId: "murallas",
			visitorId: "espartanas",
			locationId: 1,
			date: "2023-03-26T09:30:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 12,
		},
		{
			id: 6,
			homeclubId: "panas",
			visitorId: "espartanas",
			locationId: 1,
			date: "2023-03-26T11:20:00.000Z",
			scoreHomeclub: 3,
			scoreVisitor: 8,
		},
		{
			id: 7,
			homeclubId: "vikingas",
			visitorId: "aguilas",
			locationId: 1,
			date: "2023-03-26T13:10:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 1,
		},
		{
			id: 8,
			homeclubId: "tropicales",
			visitorId: "panteras",
			locationId: 1,
			date: "2023-03-26T15:00:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 6,
		},
	],
	[
		{
			id: 9,
			homeclubId: "aguilas",
			visitorId: "panteras",
			locationId: 1,
			date: "2023-04-16T09:30:00.000Z",
			scoreHomeclub: 5,
			scoreVisitor: 2,
		},
		{
			id: 10,
			homeclubId: "panas",
			visitorId: "aguilas",
			locationId: 1,
			date: "2023-04-16T11:20:00.000Z",
			scoreHomeclub: 6,
			scoreVisitor: 1,
		},
		{
			id: 11,
			homeclubId: "tropicales",
			visitorId: "murallas",
			locationId: 1,
			date: "2023-04-16T13:10:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 2,
		},
		{
			id: 12,
			homeclubId: "espartanas",
			visitorId: "vikingas",
			locationId: 1,
			date: "2023-04-16T15:00:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 4,
		},
	],
	[
		{
			id: 13,
			homeclubId: "tropicales",
			visitorId: "panas",
			locationId: 1,
			date: "2023-04-22T09:30:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 14,
			homeclubId: "panteras",
			visitorId: "murallas",
			locationId: 1,
			date: "2023-04-22T11:20:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 15,
			homeclubId: "espartanas",
			visitorId: "aguilas",
			locationId: 1,
			date: "2023-04-22T13:10:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
	],
	[
		{
			id: 16,
			homeclubId: "vikingas",
			visitorId: "panas",
			locationId: 1,
			date: "2023-04-23T09:30:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 3,
		},
		{
			id: 17,
			homeclubId: "panteras",
			visitorId: "vikingas",
			locationId: 1,
			date: "2023-04-23T11:20:00.000Z",
			scoreHomeclub: 3,
			scoreVisitor: 2,
		},
		{
			id: 18,
			homeclubId: "tropicales",
			visitorId: "espartanas",
			locationId: 1,
			date: "2023-04-23T13:10:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 13,
		},
		{
			id: 19,
			homeclubId: "aguilas",
			visitorId: "murallas",
			locationId: 1,
			date: "2023-04-23T15:00:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 1,
		},
	],
	[
		{
			id: 20,
			homeclubId: "murallas",
			visitorId: "vikingas",
			locationId: 1,
			date: "2023-05-07T09:30:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 10,
		},
		{
			id: 21,
			homeclubId: "panteras",
			visitorId: "panas",
			locationId: 1,
			date: "2023-05-07T11:20:00.000Z",
			scoreHomeclub: 3,
			scoreVisitor: 0,
		},
		{
			id: 22,
			homeclubId: "panteras",
			visitorId: "tropicales",
			locationId: 1,
			date: "2023-05-07T13:10:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 5,
		},
		{
			id: 23,
			homeclubId: "aguilas",
			visitorId: "espartanas",
			locationId: 1,
			date: "2023-05-07T15:00:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 4,
		},
	],
	[
		{
			id: 24,
			homeclubId: "panteras",
			visitorId: "espartanas",
			locationId: 1,
			date: "2023-05-14T09:30:00.000Z",
			scoreHomeclub: 9,
			scoreVisitor: 0,
		},
		// {
		// 	id: 25,
		// 	homeclubId: 'aguilas',
		// 	visitorId: 'panas',
		// 	locationId: 1,
		// 	date: "2023-05-14T11:20:00.000Z",
		// 	scoreHomeclub: 3,
		// 	scoreVisitor: 6,
		// },
		{
			id: 26,
			homeclubId: "murallas",
			visitorId: "tropicales",
			locationId: 1,
			date: "2023-05-14T13:10:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 10,
		},
		{
			id: 27,
			homeclubId: "vikingas",
			visitorId: "murallas",
			locationId: 1,
			date: "2023-05-14T15:00:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 3,
		},
	],
	[
		{
			id: 28,
			homeclubId: "panteras",
			visitorId: "aguilas",
			locationId: 2,
			date: "2023-05-20T09:30:00.000Z",
			scoreHomeclub: 10,
			scoreVisitor: 0,
		},
		{
			id: 29,
			homeclubId: "espartanas",
			visitorId: "murallas",
			locationId: 2,
			date: "2023-05-20T11:20:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 0,
		},
		{
			id: 30,
			homeclubId: "tropicales",
			visitorId: "vikingas",
			locationId: 2,
			date: "2023-05-20T13:10:00.000Z",
			scoreHomeclub: 8,
			scoreVisitor: 10,
		},
	],
	[
		{
			id: 31,
			homeclubId: "panas",
			visitorId: "tropicales",
			locationId: 3,
			date: "2023-05-21T09:30:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 0,
		},
		{
			id: 32,
			homeclubId: "espartanas",
			visitorId: "panas",
			locationId: 3,
			date: "2023-05-21T11:20:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 2,
		},
		{
			id: 33,
			homeclubId: "aguilas",
			visitorId: "vikingas",
			locationId: 3,
			date: "2023-05-21T13:10:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 4,
		},
		{
			id: 34,
			homeclubId: "murallas",
			visitorId: "panteras",
			locationId: 3,
			date: "2023-05-21T15:00:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 11,
		},
	],
	[
		{
			id: 35,
			homeclubId: "espartanas",
			visitorId: "tropicales",
			locationId: 2,
			date: "2023-05-28T09:30:00.000Z",
			scoreHomeclub: 12,
			scoreVisitor: 1,
		},
		{
			id: 36,
			homeclubId: "murallas",
			visitorId: "aguilas",
			locationId: 2,
			date: "2023-05-28T11:20:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 6,
		},
		{
			id: 37,
			homeclubId: "vikingas",
			visitorId: "panteras",
			locationId: 2,
			date: "2023-05-28T13:10:00.000Z",
			scoreHomeclub: 5,
			scoreVisitor: 5,
		},
		{
			id: 38,
			homeclubId: "panas",
			visitorId: "vikingas",
			locationId: 2,
			date: "2023-05-28T15:00:00.000Z",
			scoreHomeclub: 11,
			scoreVisitor: 5,
		},
	],
	[
		{
			id: 39,
			homeclubId: "vikingas",
			visitorId: "espartanas",
			locationId: 2,
			date: "2023-06-03T10:00:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 4,
		},
		{
			id: 42,
			homeclubId: "panas",
			visitorId: "panteras",
			locationId: 2,
			date: "2023-06-03T11:20:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 1,
		},
	],
	[
		{
			id: 40,
			homeclubId: "tropicales",
			visitorId: "aguilas",
			locationId: 4,
			date: "2023-06-04T11:30:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 1,
		},
		{
			id: 41,
			homeclubId: "murallas",
			visitorId: "panas",
			locationId: 4,
			date: "2023-06-04T13:20:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 10,
		},
	],
	[
		{
			id: 14,
			homeclubId: "panteras",
			visitorId: "murallas",
			locationId: 5,
			date: "2023-06-11T10:00:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 1,
		},
		{
			id: 13,
			homeclubId: "tropicales",
			visitorId: "panas",
			locationId: 5,
			date: "2023-06-11T11:20:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 12,
		},
		{
			id: 25,
			homeclubId: "aguilas",
			visitorId: "panas",
			locationId: 5,
			date: "2023-06-11T13:10:00.000Z",
			scoreHomeclub: 5, // 3,
			scoreVisitor: 4, // 6,
		},
		{
			id: 15,
			homeclubId: "espartanas",
			visitorId: "aguilas",
			locationId: 5,
			date: "2023-06-11T15:00:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 3,
		},
	],
	[
		{
			id: 43,
			homeclubId: "panteras", // 9,
			visitorId: "panas", // 10,
			locationId: 1,
			date: "2023-06-18T10:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
		{
			id: 44,
			homeclubId: "espartanas", // 8,
			visitorId: "vikingas", // 11,
			locationId: 1,
			date: "2023-06-18T12:15:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
	],
	[
		{
			id: 45,
			homeclubId: 3,
			visitorId: 4,
			locationId: 1,
			date: "2023-06-25T10:10:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
		{
			id: 46,
			homeclubId: 1,
			visitorId: 2,
			locationId: 1,
			date: "2023-06-25T12:15:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			title: "FINAL",
		},
	],
];
